import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CustomAccordianWithAvatar from "../../../../../../modules/atoms/Accordian/main";
import Icon from "../../../../../../icons/main";
import {
  apiEndPoints,
  convertToTitleCase,
  TOAST_AUTO_CLOSE_TIME,
  XClient_ID,
} from "../../../../../../config/config";
import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
import { useState } from "react";
import logutApi from "../../../../../../api/Auth/logout_api";
import { stateType } from "../../../../../../store/store.type";
import { toast } from "react-toastify";
const ProfileAccordian = ({ expanded }: { expanded: boolean }) => {
  // const navigate = useNavigate();
  const [logingOut, setLogingOut] = useState(false);
  const { fullName, orgnisationName } = useSelector(
    (sel: stateType) => sel.userProfileSlice.data,
  );
  const logoutHandler = async () => {
    const { LOGOUT } = apiEndPoints;

    setLogingOut(true);
    try {
      const res = await logutApi({ url: LOGOUT, XClient_ID });
      //
      setLogingOut(false);
      if (res.status === "Success") {
        window.location.reload();
      } else {
        toast.error("Something went wrong", {
          autoClose: TOAST_AUTO_CLOSE_TIME,
        });
      }
    } catch (err) {
      toast.error("Something went wrong", {
        autoClose: TOAST_AUTO_CLOSE_TIME,
      });
    }
  };
  return (
    <Box sx={{ paddingTop: "15px" }}>
      <CustomAccordianWithAvatar
        avatarSource="#"
        altText={fullName ? fullName?.trim()[0]?.toUpperCase() : ""}
        title={fullName === "" ? "" : convertToTitleCase(fullName)}
        subtitle={orgnisationName}
        expanded={expanded}
      >
        <Button
          sx={{
            width: "100%",
            textTransform: "none",
            display: "flex",
            gap: "4px",
          }}
          onClick={logoutHandler}
          disabled={logingOut}
        >
          {Icon["logout"]({
            width: { xs: "1rem" },
            height: { xs: "1rem" },
            color: "#000000",
          })}
          Logout
        </Button>
      </CustomAccordianWithAvatar>
    </Box>
  );
};

export default ProfileAccordian;
